export default from './top-comment';



// WEBPACK FOOTER //
// ./app/components/top-comment/index.js